import SettingsSnippetPreview from './settings-snippet-preview';

export default SettingsSnippetPreview;
